import {
  HStack,
  VStack,
  IconButton,
  Icon,
  chakra,
  Text,
} from "@chakra-ui/react";
import { S3Response } from "react-s3-uploader";
import { Reorder, useDragControls, useMotionValue } from "framer-motion";
import { FaGripLines, FaGripVertical, FaTrash } from "react-icons/fa";
import MediaUploadArea from "../MediaUploadArea";

const Item = chakra(Reorder.Item);

interface CarouselItemProps {
  orderIndex: number;
  item: any;
  carouselMediaType: string;
  format: "portrait";
  createPublicUploadUrl: (params: {
    file: File;
    callback: (params: S3Response) => void | Promise<void | string>;
  }) => Promise<S3Response & { cdn_url: string }>;
  updateMedia: (index: number, result: any) => void;
  removeMedia: (index: number) => void;
  handleMouseDownReorder: (e: React.PointerEvent, item: any, dc: any) => void;
}

const CarouselItem = ({
  orderIndex,
  item,
  carouselMediaType,
  format,
  createPublicUploadUrl,
  updateMedia,
  removeMedia,
  handleMouseDownReorder,
}: CarouselItemProps) => {
  const dragControls = useDragControls();
  const y = useMotionValue(0);

  return (
    <Item
      key={orderIndex}
      value={orderIndex}
      dragListener={false}
      style={{ y }}
      dragControls={dragControls}
      w="full"
      my={2}
      h={24}
      py={2}
      border="1px solid"
      userSelect="none"
      borderColor="gray.200"
      rounded="lg"
      boxShadow="sm"
      overflow="hidden"
    >
      <HStack
        w="full"
        spacing={3}
        mb={3}
        justifyContent="space-between"
        h="full"
        px={2}
        pl={0}
      >
        <HStack alignItems={"center"} w="full">
          <VStack
            p={2}
            alignContent="center"
            justifyContent="center"
            cursor="grab"
            onPointerDown={(e) => {
              handleMouseDownReorder(e, {}, dragControls);
            }}
            h="50px"
            w="40px"
            justify="center"
            color="gray.300"
          >
            <FaGripLines />
          </VStack>
          <MediaUploadArea
            width={16}
            p={0}
            noPadding={true}
            showDelete={false}
            uploadButton={false}
            ratio="4/5"
            overflow="hidden"
            mediaType={
              item && "source" in item && item.source ? "video" : "photo"
            }
            url={
              item && "source" in item && item.source
                ? item.source
                : item && "picture_url" in item && item.picture_url
                ? item.picture_url
                : undefined
            }
            createUploadUrl={createPublicUploadUrl}
            onChange={(result) => updateMedia(orderIndex, result)}
          />
          <Text fontSize={"xs"} color="gray.500">
            {(
              item?.file_key ||
              item?.fileKey ||
              item?.picture_url ||
              item?.fileKey ||
              "Add an image or video"
            )
              ?.split("/")
              .pop()}
          </Text>
        </HStack>
        <HStack>
          <IconButton
            aria-label="Edit Media"
            icon={<Icon as={FaTrash} />}
            variant="ghost"
            size="sm"
            onClick={() => {
              removeMedia(orderIndex);
            }}
          />
        </HStack>
      </HStack>
    </Item>
  );
};

export default CarouselItem;
